import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useGeneralTasksStore } from '../hooks/useGeneralTasksStore';
import { DialogState } from '@roc/ui';
import { EditTask } from './editTask/editTask';

export const SingleTaskDetailView = observer(({ taskId }) => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const [dialogState, setDialogState] = useState<DialogState | null>(null);

  useEffect(() => {
    if (taskId) {
      editTaskStore.openEditTask(taskId);
      setDialogState(DialogState.EDIT)
      window.parent.postMessage({ action: 'modal-ready' }, '*');
    }
  }, [taskId]);

  if (!taskId) {
    return <></>;
  }
  return (
    <EditTask />
  );
});
